import { containerless, bindable, bindingMode, customElement } from 'aurelia-framework';
import { inject, Parent } from 'aurelia-dependency-injection';
import { BootstrapNavItem } from './fs-nav-item';

@inject(Element, Parent.of(BootstrapNavItem))
@containerless
@customElement('fs-nav-item-header')
export class BootstrapNavItemHeader {

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public class: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public style: string;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) public href: string;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public title: string;

    @bindable({ defaultBindingMode: bindingMode.oneTime }) public active: boolean | string = false;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) public disabled: boolean | string = false;

    private isFade: boolean = false;

    public parent: any;

    private element: HTMLElement;

    public tab_header: any;

    constructor(element: Element, parent) {
        this.parent = parent;
        this.element = <HTMLElement>element;
    }


    bind(bindingContext: any, overrideContext: any) {
        this.active = this.parent.active;
        this.disabled = this.parent.disabled;

        let navs: HTMLElement;

        navs = this.tab_header.parentElement;

        let navComponent: HTMLElement;

        let tab_body_id = `${this.parent.id}-tab-body`;

        this.isFade = true;

        let data_toggle = 'tab';

        this.tab_header.setAttribute('data-toggle', data_toggle);

        this.tab_header.setAttribute('role', 'tab');
        this.tab_header.setAttribute('aria-controls', `${tab_body_id}`);
        this.tab_header.setAttribute('aria-selected', `${this.active}`);

        this.tab_header.setAttribute('href', `#${tab_body_id}`);

    }
}